<div class="toggleButton toolbarLabel">
  <input type="checkbox" id="findEntireWord" tabindex="0" />
  <label for="findEntireWord" data-l10n-id="pdfjs-find-entire-word-checkbox-label"></label>
</div>
